// extracted by mini-css-extract-plugin
module.exports = {"primary":"#505070","accent":"#e91e63","secondary":"#74748f","tertiary":"#344bb4","success":"#5252a1","info":"#2196f3","warning":"#fb8c00","danger":"#fb8c00","error":"#ff5252"};